'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/postcss/~/supports-color/browser.js
// module id = 1507
// module chunks = 6